import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeDailyRegisterTransformer  {
    _originalTypeClassName = "zERP.BO.BackOfficeDailyRegisterTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeDailyRegisterTransformer.translate = translateService;
}
this.BackOfficeDailyRegisterTransformerKey = null;
this._key = this.BackOfficeDailyRegisterTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeDailyRegisterTransformerKey:any;
get BackOfficeDailyRegisterTransformerKey(): any {
    return this._BackOfficeDailyRegisterTransformerKey;
  }
set BackOfficeDailyRegisterTransformerKey(value: any) {
    this._BackOfficeDailyRegisterTransformerKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeDailyRegisterTransformerKey == null || $this.BackOfficeDailyRegisterTransformerKey == 0;
            }


}